import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import type { GuardProps } from 'types/auth';

export default function PlatformAdminGuard({ children }: GuardProps) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/" replace />;
}
